var styles = {"fontElementMap":"BbRaT","orderedlist":"YvjYr","bulletedlist":"L5kI2","listItem":"wDLQ0"};

export { styles as s };
//# sourceMappingURL=lists-296811a3.js.map
